export default defineAppConfig({
  ui: {
    primary: "wh-teal",
    button: {
      variant: {
        solid: "text-black",
      },
    },
    badge: {
      variant: {
        solid: "text-black",
      },
    },
    chip: {
      base: "text-black",
    },
  },
});
